import { Section } from '@/components/layout';
import { ResponsiveImage } from '@/components/media';
import { SacredGeometry, Sparkle } from '@/components/ornaments';
import { Reveal } from '@/components/motion';
import { cancunMedia } from '../media';
import { CANCUN_COPY } from '../copy';
import { GoldWing } from '../ornaments/GoldWing';
import styles from './AzrahelCancun.module.css';

const TITLE_ID = 'cancun-azrahel';

/**
 * S4 · BLOQUE AZRAHEL + GEOMETRÍA SAGRADA — banda y 1278-1536. Cierre de marca.
 *
 * Tres zonas: retrato a sangre a la izquierda fundido en el crema, bloque
 * tipográfico alineado a la izquierda, y la gran geometría sagrada dorada
 * recortada por el borde derecho — no cabe entera, y así debe ser.
 *
 * La geometría es SVG del substrato (`SacredGeometry`), no una imagen: un
 * ornamento geométrico se dibuja (ADR-004 §1.3).
 */
export function AzrahelCancun() {
  const { cierre } = CANCUN_COPY;

  return (
    <Section width="full" spacing="flush" background="surface" labelledBy={TITLE_ID} className={styles.section}>
      <div className={styles.layout}>
        <div className={styles.portraitZone}>
          <ResponsiveImage
            asset={cancunMedia.closingPortrait}
            sizes="(min-width: 64rem) 30vw, 100vw"
            className={styles.portrait}
          />
        </div>

        <Reveal className={styles.body}>
          <h2 id={TITLE_ID} className={styles.name}>
            <span>{cierre.name}</span>
            <GoldWing size={38} className={styles.wing} />
          </h2>

          <p className={styles.role}>
            {cierre.role.map((word) => (
              <span key={word}>{word}</span>
            ))}
          </p>

          <p className={styles.bio}>{cierre.bio}</p>

          <p className={styles.mark}>
            <span className={styles.markRule} />
            <Sparkle size={16} />
            <span className={styles.markRule} />
          </p>

          <p className={styles.legacy}>
            {cierre.legacy.map((word) => (
              <span key={word}>{word}</span>
            ))}
          </p>
        </Reveal>

        <SacredGeometry variant="metatron" size={420} className={styles.geometry} />
      </div>
    </Section>
  );
}
